import clsx from "clsx";

const NotifyDot: React.FC = () => {
  return (
    <span
      className={clsx([
        "absolute",
        "top-0",
        "right-0",
        "-mt-1",
        "-mr-1",
        "flex",
        "size-3",
      ])}
    >
      <span
        className={clsx([
          "absolute",
          "inline-flex",
          "h-full",
          "w-full",
          "animate-ping",
          "rounded-full",
          "bg-sky-400",
          "dark:bg-purple-400",
          "opacity-75",
        ])}
      />
      <span
        className={clsx([
          "relative",
          "inline-flex",
          "size-3",
          "rounded-full",
          "bg-sky-500",
          "dark:bg-purple-500",
        ])}
      />
    </span>
  );
};

export default NotifyDot;
